/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fixGringottsAccountHolderName} from '../api'

export const useMutationFixGringottsAccountHolderName = createReactQueryMutationHook('fixGringottsAccountHolderName', fixGringottsAccountHolderName)
